/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeasonPassStatus } from './SeasonPassStatus';
import {
    SeasonPassStatusFromJSON,
    SeasonPassStatusFromJSONTyped,
    SeasonPassStatusToJSON,
    SeasonPassStatusToJSONTyped,
} from './SeasonPassStatus';
import type { SeasonScopeType } from './SeasonScopeType';
import {
    SeasonScopeTypeFromJSON,
    SeasonScopeTypeFromJSONTyped,
    SeasonScopeTypeToJSON,
    SeasonScopeTypeToJSONTyped,
} from './SeasonScopeType';
import type { SeasonTier } from './SeasonTier';
import {
    SeasonTierFromJSON,
    SeasonTierFromJSONTyped,
    SeasonTierToJSON,
    SeasonTierToJSONTyped,
} from './SeasonTier';
import type { SeasonProgressionRule } from './SeasonProgressionRule';
import {
    SeasonProgressionRuleFromJSON,
    SeasonProgressionRuleFromJSONTyped,
    SeasonProgressionRuleToJSON,
    SeasonProgressionRuleToJSONTyped,
} from './SeasonProgressionRule';

/**
 * 
 * @export
 * @interface CreateSeasonPassBody
 */
export interface CreateSeasonPassBody {
    /**
     * 
     * @type {string}
     * @memberof CreateSeasonPassBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSeasonPassBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSeasonPassBody
     */
    imageAssetId?: string;
    /**
     * 
     * @type {SeasonScopeType}
     * @memberof CreateSeasonPassBody
     */
    scopeType: SeasonScopeType;
    /**
     * 
     * @type {string}
     * @memberof CreateSeasonPassBody
     */
    scopeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSeasonPassBody
     */
    sponsorBrandId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateSeasonPassBody
     */
    startDate: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSeasonPassBody
     */
    endDate: number;
    /**
     * 
     * @type {SeasonPassStatus}
     * @memberof CreateSeasonPassBody
     */
    status?: SeasonPassStatus;
    /**
     * 
     * @type {Array<SeasonProgressionRule>}
     * @memberof CreateSeasonPassBody
     */
    progressionRules?: Array<SeasonProgressionRule>;
    /**
     * 
     * @type {Array<SeasonTier>}
     * @memberof CreateSeasonPassBody
     */
    tiers?: Array<SeasonTier>;
    /**
     * 
     * @type {string}
     * @memberof CreateSeasonPassBody
     */
    leaderboardCompetitionId?: string;
}



/**
 * Check if a given object implements the CreateSeasonPassBody interface.
 */
export function instanceOfCreateSeasonPassBody(value: object): value is CreateSeasonPassBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('scopeType' in value) || value['scopeType'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    return true;
}

export function CreateSeasonPassBodyFromJSON(json: any): CreateSeasonPassBody {
    return CreateSeasonPassBodyFromJSONTyped(json, false);
}

export function CreateSeasonPassBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSeasonPassBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageAssetId': json['imageAssetId'] == null ? undefined : json['imageAssetId'],
        'scopeType': SeasonScopeTypeFromJSON(json['scopeType']),
        'scopeId': json['scopeId'] == null ? undefined : json['scopeId'],
        'sponsorBrandId': json['sponsorBrandId'] == null ? undefined : json['sponsorBrandId'],
        'startDate': json['startDate'],
        'endDate': json['endDate'],
        'status': json['status'] == null ? undefined : SeasonPassStatusFromJSON(json['status']),
        'progressionRules': json['progressionRules'] == null ? undefined : ((json['progressionRules'] as Array<any>).map(SeasonProgressionRuleFromJSON)),
        'tiers': json['tiers'] == null ? undefined : ((json['tiers'] as Array<any>).map(SeasonTierFromJSON)),
        'leaderboardCompetitionId': json['leaderboardCompetitionId'] == null ? undefined : json['leaderboardCompetitionId'],
    };
}

export function CreateSeasonPassBodyToJSON(json: any): CreateSeasonPassBody {
    return CreateSeasonPassBodyToJSONTyped(json, false);
}

export function CreateSeasonPassBodyToJSONTyped(value?: CreateSeasonPassBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'imageAssetId': value['imageAssetId'],
        'scopeType': SeasonScopeTypeToJSON(value['scopeType']),
        'scopeId': value['scopeId'],
        'sponsorBrandId': value['sponsorBrandId'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'status': SeasonPassStatusToJSON(value['status']),
        'progressionRules': value['progressionRules'] == null ? undefined : ((value['progressionRules'] as Array<any>).map(SeasonProgressionRuleToJSON)),
        'tiers': value['tiers'] == null ? undefined : ((value['tiers'] as Array<any>).map(SeasonTierToJSON)),
        'leaderboardCompetitionId': value['leaderboardCompetitionId'],
    };
}

